import { render, staticRenderFns } from "./CallRestaurant.vue?vue&type=template&id=77a1459d&scoped=true"
import script from "./CallRestaurant.vue?vue&type=script&lang=js"
export * from "./CallRestaurant.vue?vue&type=script&lang=js"
import style0 from "./CallRestaurant.vue?vue&type=style&index=0&id=77a1459d&prod&lang=scss&module=true&scoped=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "77a1459d",
  null
  
)

export default component.exports